import { FC } from 'react';
import { useFormContext } from '../../../../../../contexts/FormContext';
import { OutputTextarea } from '../OutputTextarea';
import { EmailCard } from './EmailCard';

import styles from './EmailOutputs.module.css';

export const PersonaEmailOutputs: FC = () => {
  const { editedOutput } = useFormContext();

  return (
    <div className={styles['container']}>
      {editedOutput.map(({ text }, index) => (
        <EmailCard key={text} responseIndex={index} text={text} />
      ))}
      <OutputTextarea />
      {/* {generatedOutput.length > 0 && (
        <BasicButton
          type="button"
          text="Load More"
          disabled={loading}
          loading={loading}
          onClick={() => {
            submitForm({
              values: emailInput,
              formType: FormType.EMAIL,
              keepPreviousResponses: true,
            });
          }}
          extraStyles={{
            margin: '30px auto',
            zIndex: 5,
          }}
        />
      )} */}
    </div>
  );
};
